import { useCallback, useEffect, useState } from 'react';
import { Button, Checkbox, Modal, Space } from 'antd';
import type { ReportKind } from '../../../store/reducers/ReportSlice';
import styles from './style.module.css';

interface Props {
  open: boolean;
  loading: boolean;
  onCancel: () => void;
  onGenerate: (reportKinds: readonly ReportKind[]) => void;
}

const DEFAULT_REPORT_KINDS: readonly ReportKind[] = ['journal'];

export const OutgoingReportTypeModal = ({
  open,
  loading,
  onCancel,
  onGenerate,
}: Props) => {
  const [selectedReportKinds, setSelectedReportKinds] =
    useState<readonly ReportKind[]>(DEFAULT_REPORT_KINDS);

  useEffect(() => {
    if (open) {
      setSelectedReportKinds(DEFAULT_REPORT_KINDS);
    }
  }, [open]);

  const handleReportKindChange = useCallback(
    (reportKind: ReportKind, checked: boolean) => {
      setSelectedReportKinds((current) =>
        checked
          ? [...current, reportKind]
          : current.filter((kind) => kind !== reportKind),
      );
    },
    [],
  );

  return (
    <Modal
      className={styles.modal}
      title="Сформировать отчет"
      open={open}
      width={400}
      onCancel={onCancel}
      closable={!loading}
      maskClosable={!loading}
      keyboard={!loading}
      footer={
        <Button
          type="primary"
          loading={loading}
          disabled={selectedReportKinds.length === 0 || loading}
          onClick={() => onGenerate(selectedReportKinds)}
        >
          Сформировать
        </Button>
      }
    >
      <Space className={styles.options} direction="vertical" size={8}>
        <Checkbox
          checked={selectedReportKinds.includes('journal')}
          disabled={loading}
          onChange={(event) =>
            handleReportKindChange('journal', event.target.checked)
          }
        >
          Журнал заданий (*.xlsx)
        </Checkbox>
        <Checkbox
          checked={selectedReportKinds.includes('summary')}
          disabled={loading}
          onChange={(event) =>
            handleReportKindChange('summary', event.target.checked)
          }
        >
          Сводный отчет по заданиям (*.xlsx)
        </Checkbox>
      </Space>
    </Modal>
  );
};
